module.exports = __webpack_public_path__ + "img/rafting-3.e4f03143.jpeg";